import { UserRoleScopes } from './UserRoleScopes';
import { UserRolesBehavior, UserRolesType } from './UserRole';
import { UserRoleNotifications } from './UserRoleNotifications';
import { z } from 'zod';

export interface CreateUserRoleDTO {
  name: string;
  behavior: UserRolesBehavior;
  type: UserRolesType;
  branchID?: number;
  podID?: number;
  scopes: UserRoleScopes;
  notifications: UserRoleNotifications;
}

export type UpdateUserRoleDTO = Partial<CreateUserRoleDTO>;

export const Permissions = {
  ManageRoles: 'manage-roles',
  AccessDashboardApp: 'access-dashboard-app',
  AccessAdBuilderApp: 'access-ad-builder-app',
  AccessAdminApp: 'access-admin-app',
  ReadAllUsers: 'read-all-users',
  ReadPodUsers: 'read-pod-users',
  ReviewOfflineEventUpload: 'review-offline-event-upload',
  ReviewBadDataRequest: 'review-bad-data-requests',
  ManageSupportDesk: 'manage-support-desk',
  AccessAllBusinesses: 'access-all-businesses',
  ManageGoodDataAccess: 'manage-gooddata-access',
  ViewGoodDataDashboards: 'view-gooddata-dashboards',
} as const;

export type Auth0Permissions = typeof Permissions[keyof typeof Permissions];

export type Auth0RolePermission = {
  description: string;
  value: Auth0Permissions;
};

export const Auth0PermissionZod = z.array(
  z.object({
    description: z.string(),
    value: z.nativeEnum(Permissions),
  }),
);

/**
 * Role types for Auth0
 */

export const Auth0RoleZod = z.object({
  id: z.string().optional(),
  name: z.string(),
  description: z.string(),
});

export type Auth0Role = z.infer<typeof Auth0RoleZod>;

/**
 * Users by roles type
 */
export type Auth0RolesUser = {
  user_id: string;
  picture: string;
  name: string;
  email: string;
};

export const userAuth0IdSchema = z.object({
  email: z.string().email(),
  auth0Id: z.string(),
  rolesConfigured: z.boolean(),
});
export const userAssignedRoleSchema = z.object({
  email: z.string().email(),
  roleId: z.string(),
  createdAt: z.string().transform((date) => new Date(date)),
});

export type UserAuth0IdSchema = z.infer<typeof userAuth0IdSchema>;
export type UserAssignedRoleSchema = z.infer<typeof userAssignedRoleSchema>;
export type UserAuth0IdSchemaDTO = Partial<UserAuth0IdSchema>;
export type UserAssignedRoleSchemaDTO = Partial<UserAssignedRoleSchema>;
